import React from "react";
import Field from "../Common/Field";
import DatePicker from "../Common/DatePicker";
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import "moment/locale/de";

export default class Date extends Field {
  getValueFormat() {
    const config = this.props.config;
    return config.valueFormat || config.inputFormat || config.defaultFormat;
  }

  getRuleDate(type) {
    const { validation } = this.props.config;
    if (!validation || !validation.rules) return null;

    const rule = validation.rules.find((rule) => rule.type === type);
    if (!rule || !rule.params || !rule.params[0]) return null;

    const format = this.getValueFormat();
    const formatted = moment(rule.params[0], format, true);
    return formatted && formatted.isValid() ? formatted : null;
  }

  renderInput() {
    const { config, formikForm, formikField, isRequired, form } = this.props;
    const {
      label,
      name,
      placeholder,
      locale,
      readOnly,
      disabled,
      valueFormat,
      inputFormat,
      displayFormat,
      invalidDate,
    } = config;

    moment.locale(locale);
    const minDate = this.getRuleDate("min");
    const maxDate = this.getRuleDate("max");

    var render = (
      <div className="field__input field__input--date">
        <DatePicker
          label={label}
          name={name}
          value={formikField.value}
          valueFormat={valueFormat}
          inputFormat={inputFormat}
          displayFormat={displayFormat}
          placeholder={placeholder}
          locale={locale}
          minDate={minDate}
          maxDate={maxDate}
          readOnly={readOnly}
          disabled={disabled}
          aria-required={!!isRequired}
          invalidDate={invalidDate}
          onChange={(value, displayValue) => {
            formikForm.setFieldValue(name, value, true);
            form.fieldChanged(name, displayValue);
          }}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
        />
      </div>
    );

    return render;
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Date.js